import { trans } from '@spotahome/soyuz/client';

import Section from '@spotahome/ui-library/src/tenant/components/LandingSection/LandingSection';

import './Partners.scss';

const partners = [
  'accenture',
  'comillas',
  'esn',
  'nouva-accdemia-di-belle-arti',
  'tecnologico-de-monterry',
  'bbs',
  'eada',
  'ied',
  'tecnico-lisboa',
  'universita-milano'
];

const Partners = () => {
  const marqueePartners = [...partners, ...partners].map((partner, idx) => ({
    id: `${partner}-${idx}`,
    partner
  }));
  return (
    <Section className="hiw-partners">
      <div className="hiw-partners__text">
        {trans('how_it_works.partners.text')}
      </div>
      <div className="hiw-partners__logos">
        <div className="hiw-partners__logos-items">
          {marqueePartners.map(partnerData => {
            return (
              <img
                key={partnerData.id}
                alt={partnerData.partner}
                src={`https://static.spotahome.com/images/how-it-works/partners/${partnerData.partner}.png`}
                loading="lazy"
              />
            );
          })}
        </div>
      </div>
    </Section>
  );
};

export default Partners;
